import { useTabStore } from '@/stores/tabStore'
import { CloseOutlined, MoreOutlined } from '@ant-design/icons'
import { Dropdown, Tabs } from 'antd'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useLayoutStore } from '../../stores/layoutStore'
import './index.scss'

const TabBar: React.FC = observer(() => {
  const tabStore = useTabStore()
  const layoutStore = useLayoutStore()
  const navigate = useNavigate()

  const handleTabChange = (activeKey: string) => {
    tabStore.setActiveKey(activeKey)
    // 同步展开对应的左侧菜单
    const pathToMenuMap: { [key: string]: string } = {
      '/modules/list': '/modules',
      '/firmware/list': '/firmware',
      '/firmware/ota': '/firmware',
      '/campaigns/list': '/campaigns',
      '/campaigns/force-upgrade': '/campaigns',
      '/devices/list': '/devices',
      '/logs/list': '/logs',
    }

    const menuKey = pathToMenuMap[activeKey]
    if (menuKey) {
      layoutStore.setOpenKeys([menuKey])
    }
    navigate(activeKey)
  }

  const handleTabEdit = (
    targetKey: React.MouseEvent | React.KeyboardEvent | string,
    action: 'add' | 'remove'
  ) => {
    if (action === 'remove') {
      const tab = tabStore.tabs.find(t => t.key === targetKey)
      if (tab?.closable !== false) {
        tabStore.removeTab(targetKey as string)
        // 如果关闭的是当前标签，需要导航到新的激活标签
        if (tabStore.activeKey !== targetKey) {
          navigate(tabStore.activeKey)
        }
      }
    }
  }

  const moreMenuItems = [
    {
      key: 'closeOthers',
      label: '关闭其他',
      onClick: () => {
        tabStore.closeOthers(tabStore.activeKey)
      },
    },
    {
      key: 'closeAll',
      label: '关闭所有',
      onClick: () => {
        tabStore.closeAll()
        navigate(tabStore.activeKey)
      },
    },
  ]

  const renderTabLabel = (tab: any) => (
    <div className='tab-label'>
      <span className='tab-title'>{tab.label}</span>
      {tab.closable !== false && (
        <CloseOutlined
          className='tab-close'
          onClick={e => {
            e.stopPropagation()
            handleTabEdit(tab.key, 'remove')
          }}
        />
      )}
    </div>
  )

  const items = tabStore.tabs.map(tab => ({
    key: tab.key,
    label: renderTabLabel(tab),
    closable: tab.closable !== false,
  }))

  return (
    <div className='tab-bar'>
      <Tabs
        type='editable-card'
        activeKey={tabStore.activeKey}
        onChange={handleTabChange}
        onEdit={handleTabEdit}
        items={items}
        hideAdd
        size='small'
        tabBarExtraContent={
          <Dropdown menu={{ items: moreMenuItems }} placement='bottomRight'>
            <div className='tab-more'>
              <MoreOutlined />
            </div>
          </Dropdown>
        }
      />
    </div>
  )
})

export default TabBar
